import React from 'react';
import * as S from './styled';
// import logoAlternativa from '../../assets/images/AD_new.png';
import logoSindigital from '../../assets/images/sind_new.png';
import Ad from '../../assets/images/AD.png';
import Fetrafi from '../../assets/images/fetrafi.png';

const FooterLogin = () => {
    return (
        <S.Footer>
            <S.Assinatura>
                <img src={logoSindigital} alt="Logo Sindigital" />
            </S.Assinatura>
            <S.TextLight>© Copyright 2023-2024 Copyright.com.br - Todos os direitos reservados à Alternativa Digital</S.TextLight>
            <S.Assinatura>
                {/* <img src={logoAlternativa} alt="Logo Alternativa Digital" /> */}
                <img src={Fetrafi} alt="Fetrafi" width="70px" />
                <img src={Ad} alt="Alteranativa Digital" width="70px" />
            </S.Assinatura>
            <S.Versao>
                VERSÃO 1.54
            </S.Versao>
        </S.Footer>
    );
};

export default FooterLogin;